<template>
  <div class="clinic-template-tab" v-loader.opacity.tab="loading">
    <div class="clinic-template-list" id="template-list" v-if="!isEditTemplate">
      <BaseTable class="no-border" v-if="tableTemplates" :tabledata="tableTemplates" @item-opened="toDetails"/>

      <button class="btn-icon btn-top" type="button" name="button" v-if="currentPage > 1 && tableTemplates.items.length > 20" @click="goTop">
        <IconArrowUp/>
      </button>
    </div>

    <div class="clinic-edit-box" v-else>
      <ClinicTemplateEdit :template_id="template ? template.id : null" @cancel-edit="cancelEditTemplate"/>
    </div>

    <div class="action-bar" v-if="!isEditTemplate" @wheel.prevent>
      <button class="btn btn-success" type="button" name="button" data-test="btnBack" v-if="!isEditTemplate" @click="isEditTemplate = !isEditTemplate">
        <span>{{ $t('clinic.newTemplate') }}</span>
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.clinic-template-list {
  padding:                         0 10px 10px 10px;
}

@media (min-width: 992px) {
  .clinic-template-tab {
    display:                       flex;
    flex-direction:                column;
    flex:                          1;
    min-height:                    0;
  }

  .clinic-template-list {
    display:                       flex;
    flex-direction:                column;
    flex:                          1;
    min-height:                    0;
    overflow:                      hidden;
  }

  .clinic-edit-box {
    display:                       flex;
    flex-direction:                column;
    flex:                          1;
    min-height:                    0;
  }

  .action-bar {
    position:                      sticky;
    bottom:                        0;
    z-index:                       2;
    background:                    var(--Shades-W);
  }
}

@media (max-width: 991px) {
  .clinic-template-list {
    height:                        calc(100dvh - 258px);
    max-height:                    calc(100dvh - 258px);
    padding:                       0;
    overflow-y:                    auto;
    overscroll-behavior:           contain;
    scrollbar-width:               none;

    &::-webkit-scrollbar {
      display:                     none;
    }

    :deep(.inside-box-mob) {
      max-height:                  calc(100dvh - 258px) !important;
    }
  }

  .has-alert {
    .clinic-template-list {
      height:                      calc(100dvh - 336px);
      max-height:                  calc(100dvh - 336px);
      :deep(.inside-box-mob) {
        max-height:                calc(100dvh - 336px) !important;
      }
    }

    .clinic-edit-box {
      .title-box {
        margin-bottom: 0 !important;
      }
    }
  }

  .has-usage-bar {
    .clinic-template-list{
      height:                      calc(100dvh - 286px);
      max-height:                  calc(100dvh - 286px);
      :deep(.inside-box-mob) {
        max-height:                calc(100dvh - 286px) !important;
      }
    }
  }
}

@media screen and (min-width: 992px) and (max-width: 1365px) {
  .clinic-template-list {
    // height:                        calc(100dvh - 309px); // replaced by flex: 1 in _scaffold.scss
    // max-height:                    calc(100dvh - 258px);
  }

  .has-alert {
    .clinic-template-list {
      // height:                      calc(100dvh - 373px); // replaced by flex: 1 in _scaffold.scss
      // max-height:                  calc(100dvh - 373px); // replaced by flex: 1 in _scaffold.scss
    }
  }
}
</style>

<script>
import ClinicTemplateEdit from './ClinicTemplateEdit.vue'

export default {
  name: 'ClinicTemplateTab',
  components: {
    ClinicTemplateEdit,
  },
  data: () => ({
    loading: false,
    alert: {
      message: null,
      class: null
    },
    tableTemplates: null,
    isEditTemplate: false,
    template: null,
  }),
  async mounted() {
    this.template = null
    this.fetchData();
  },
  provide() {
    return {
      scrollToTop: (callback) => {
        this.scrollTopCallback = callback;
      }
    };
  },
  methods: {
    goTop() {
      if (this.scrollTopCallback) {
        this.scrollTopCallback();
      }

      this.$nextTick(() => {
        this.currentPage = 1

        this.fetchData()
      })
    },
    async fetchData() {
      this.alert.message = undefined;

      this.loading = true
      NProgress.start()
      try {
        let params = {
          // page: this.currentPage,
        }

        let response = await this.$clinicService.listTemplates(params);

        this.tableTemplates = {
          'items': response.result,
          'columns': [
            {name: this.$i18n.t('name'), type: 'string', value: 'name', width: '35%'},
            {name: this.$i18n.t('description'), type: 'string', value: 'description', width: '65%'},
          ]
        }
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
      }
      NProgress.done(true)
      this.loading = false
    },
    toDetails(values) {
      if (!values) {
        return
      }
      let item = values.item
      if (!item) {
        return
      }
      this.template = item;
      this.isEditTemplate = true;
    },
    cancelEditTemplate() {
      this.template = null
      this.isEditTemplate = false;
    }
  }
}
</script>
